import cx from "classnames";
import { ForwardedRef, forwardRef } from "react";

import { AnalyticsCommonProps } from "hooks/useAnalytics";
import { IconComponent } from "types/Icon";

import LinkButton, { LinkButtonProps } from "../Button/LinkButton";
import Tooltip from "../Tooltip";
import { TooltipProps } from "../Tooltip/types";
import styles from "./styles.module.css";

type LinkButtonIconProps = LinkButtonProps & {
  icon: IconComponent;
  iconRotate?: LinkButtonProps["startIconRotate"];
  tooltipPlacement?: TooltipProps["placement"];
  disableTooltip?: boolean;
  tooltipMode?: TooltipProps["mode"];
} & AnalyticsCommonProps;

const LinkButtonIcon = forwardRef(function ButtonIcon(
  props: LinkButtonIconProps,
  ref: ForwardedRef<HTMLElement>
) {
  const {
    size = "small",
    children,
    className,
    icon,
    iconRotate,
    tooltipPlacement,
    disableTooltip,
    tooltipMode,
    ...restProps
  } = props;

  return (
    <Tooltip
      ref={ref}
      mode={tooltipMode}
      placement={tooltipPlacement}
      widthMode="maxWidthSm"
      on={(tooltipProps) => (
        <LinkButton
          className={cx(styles.buttonIcon, styles[size], className)}
          size={size}
          startIcon={icon}
          startIconRotate={iconRotate}
          aria-label={children}
          {...restProps}
          {...tooltipProps}
        >
          {
            "" /* Use empty string, as button has required children for a11y purposes, ButtonIcon handles label via aria-label */
          }
        </LinkButton>
      )}
      active={!restProps.disabled && !disableTooltip}
      disableAriaLabel
    >
      {children}
    </Tooltip>
  );
});

LinkButtonIcon.displayName = "DS.LinkButtonIcon";

export default LinkButtonIcon;
